import React from "react";
import { Outlet } from "react-router-dom";

// Components
import { Navbar } from "../Navbar";

export const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};
